module.exports = __webpack_public_path__ + "static/media/Codequest_poster.236d2abc.jpg";